import React from "react";
import MDBox from "components/MDBox";
import SendNotification from "./components/notification";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
function Notification() {
  return (
    <DashboardLayout>
      <MDBox sx={{ display: "flex", justifyContent: "center" }}>
        <SendNotification />
      </MDBox>
    </DashboardLayout>
  );
}

export default Notification;
